import React, { Component } from 'react'
import ActionModal from 'frontend/components/action-modal'
import PropTypes from 'prop-types'

export default class ProceedWithRoomModal extends Component {
  renderBody () {
    return (
      <div>
        <div className="icon">&nbsp;</div>
        <h3>OOPS</h3>
        <p>
          You can only book rooms at the same location within an order. Please continue to
          checkout.
        </p>
      </div>
    )
  }

  render () {
    return (
      <ActionModal
        body={this.renderBody()}
        className="slot_action_modal proceed_with_room_modal"
        leftButtonLabel="Go to Checkout"
        onLeftClick={this.props.onProceedWithPrevious}
        onClose={this.props.onClose}
        showCloseButton={false}
      />
    )
  }
}

ProceedWithRoomModal.propTypes = {
  onProceedWithPrevious: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}
